export enum ZoomEnum {
    In = 0.2,
    Out = -0.2,
    Reset = 1,
}
